import { gql } from '@apollo/client';

export const GET_DISPATCH_DELIVERY_SUMMARY_PAGE = gql`
    query GetDispatchDeliverySummaryPage($filter: DispatchDeliverySummaryFilterInput!, $pageRequest: DispatchDeliverySummaryPageRequestInput) {
        getDispatchDeliverySummaryPage(filter: $filter, pageRequest: $pageRequest) {
            items {
                id
                hubId
                dspId
                dspName
                warehouseId
                warehouseName
                statDate
                statWeek
                statMonth
                actualArrivalsCount
                t0DeliveredCount
                t1DeliveredCount
                t2DeliveredCount
                t3DeliveredCount
                t0DeliveredRate
                t1DeliveredRate
                t2DeliveredRate
                t3DeliveredRate
                calculatedAt
                weekDateRange
                isIncompleteWeek
                monthDateRange
                isIncompleteMonth
            }
            page
            size
            total
            isDataCalculated
        }
    }
`;

export const GET_DISPATCH_DELIVERY_SUMMARY_FILTER_OPTIONS = gql`
    query GetDispatchDeliverySummaryFilterOptions($hubId: Long, $whsId: Long, $dspId: Long) {
        getDispatchDeliverySummaryFilterOptions(hubId: $hubId, whsId: $whsId, dspId: $dspId) {
            dsps {
                id
                name
            }
            warehouses {
                id
                name
            }
        }
    }
`;

export interface DispatchDeliverySummaryRecord {
    id: number;
    hubId: number;
    dspId: number;
    dspName?: string;
    warehouseId: number;
    warehouseName?: string;
    statDate: string;
    statWeek: string;
    statMonth: string;
    actualArrivalsCount: number;
    t0DeliveredCount: number;
    t1DeliveredCount: number;
    t2DeliveredCount: number;
    t3DeliveredCount: number;
    t0DeliveredRate?: number;
    t1DeliveredRate?: number;
    t2DeliveredRate?: number;
    t3DeliveredRate?: number;
    calculatedAt: string;
    weekDateRange?: string;
    isIncompleteWeek?: boolean;
    monthDateRange?: string;
    isIncompleteMonth?: boolean;
}

export interface DispatchDeliverySummaryPageResponse {
    getDispatchDeliverySummaryPage: {
        items: DispatchDeliverySummaryRecord[];
        page: number;
        size: number;
        total: number;
        isDataCalculated: boolean;
    };
}

export interface DispatchDeliverySummaryDspOptionType {
    id: number;
    name: string;
}

export interface DispatchDeliverySummaryWarehouseOptionType {
    id: number;
    name: string;
}

export interface DispatchDeliverySummaryFilterOptionsResponse {
    getDispatchDeliverySummaryFilterOptions: {
        dsps: DispatchDeliverySummaryDspOptionType[];
        warehouses: DispatchDeliverySummaryWarehouseOptionType[];
    };
}

export type DispatchDeliverySummaryGroupingMode =
    | 'NONE'
    | 'DSP'
    | 'WAREHOUSE'
    | 'DSP_WAREHOUSE';

